import { FormattedMessage } from 'react-intl'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {GroupDiscountsListFilter} from './GroupDiscountsListFilter'

const GroupDiscountsListToolbar = () => {
  const {setItemIdForUpdate} = useListView()
  const openAddGroupDiscountModal = () => {
    setItemIdForUpdate(null)
  }

  return (
    <div className='d-flex justify-content-end' data-kt-groupdiscount-table-toolbar='base'>
      <GroupDiscountsListFilter />

      {/* begin::Export */}
      <button type='button' className='btn btn-light-primary me-3'>
        <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
        <FormattedMessage id='TABLE.GENERAL.EXPORT' />      </button>
      {/* end::Export */}

      {/* begin::Add groupdiscount */}
      <button type='button' className='btn btn-primary' onClick={openAddGroupDiscountModal}>
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
        <FormattedMessage id='GROUPDISCOUNT.TABLE.CREATEGROUPDISCOUNT' defaultMessage={"Add GroupDiscount"} />
      </button>
      {/* end::Add groupdiscount */}
    </div>
  )
}

export {GroupDiscountsListToolbar}
